<div class="loading-spinner" *ngIf="loading?.isLoading && !loading?.isSilent" [@fadeIn]>
  <div class="loading-wrapper">
    <div>
      <mat-spinner color="accent" [@fadeIn]> </mat-spinner>
    </div>

    <div class="loading-message">
      <h3>
        {{ loading.message }}
      </h3>
    </div>
  </div>
</div>
